const TvgContactForm = {
  init() {
    document.querySelectorAll<HTMLFormElement>('[data-tvg-contact-form]').forEach((form) => {
      const submitButton = form.querySelector<HTMLButtonElement>('[data-tvg-contact-form-submit]')

      if (!submitButton) {
        return
      }

      // The button opens once every required field holds a valid value.
      const update = () => {
        submitButton.disabled = !form.checkValidity()
      }

      form.addEventListener('input', update)
      form.addEventListener('change', update)
      update()
    })
  },
}

export default TvgContactForm
